import axios from 'axios';
import {
  GET_COURSES,
  GET_COURSES_LIST,
  GET_COURSES_MINIMAL,
  GET_COURSE,
  ADD_COURSE,
  DELETE_COURSE,
  UPDATE_COURSE,
  COURSES_LOADING,
  COURSE_LOADING,
  CLEAR_CURRENT_COURSE,
  SET_COURSES_PAGE
} from './types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';

// Get minimal courses for dropdowns/pickers (lightweight, no pagination)
export const getCoursesMinimal = () => (dispatch, getState) => {
  dispatch(setCoursesLoading());
  axios
    .get('/api/courses/minimal', tokenConfig(getState))
    .then(res => dispatch({ type: GET_COURSES_MINIMAL, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// Get lightweight courses list with pagination and filtering (for table display)
export const getCoursesList = (page = 1, limit = 10, filters = {}) => (dispatch, getState) => {
  dispatch(setCoursesLoading());

  // Build query string with pagination and filters
  let queryParams = `page=${page}&limit=${limit}`;
  
  if (filters.courseIds && filters.courseIds.length > 0) {
    queryParams += `&courseIds=${filters.courseIds.map(id => encodeURIComponent(id)).join(',')}`;
  }
  if (filters.title && filters.title.length > 0) {
    queryParams += `&title=${filters.title.map(value => encodeURIComponent(value)).join(',')}`;
  }
  if (filters.tags && filters.tags.length > 0) {
    queryParams += `&tags=${filters.tags.map(id => encodeURIComponent(id)).join(',')}`;
  }

  axios
    .get(`/api/courses/list?${queryParams}`, tokenConfig(getState))
    .then(res => dispatch({ type: GET_COURSES_LIST, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// Get single course by ID (for view/edit pages)
export const getCourse = (id) => (dispatch, getState) => {
  dispatch(setCourseLoading());
  axios
    .get(`/api/courses/${id}`, tokenConfig(getState))
    .then(res => dispatch({ type: GET_COURSE, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// Clear current course
export const clearCurrentCourse = () => {
  return { type: CLEAR_CURRENT_COURSE };
};

// DEPRECATED: Use getCoursesList() instead
export const getCourses = () => (dispatch, getState) => {
  dispatch({ type: COURSES_LOADING });
  axios
    .get('/api/courses', tokenConfig(getState))
    .then(res => dispatch({ type: GET_COURSES, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const addCourse = course => (dispatch, getState) => {
  // Get token but don't set Content-Type (browser will set it with boundary for FormData)
  const token = getState().auth.token;

  const config = {
    headers: {}
  };
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token;
  }

  return axios
    .post('/api/courses', course, config)
    .then(res => {
      dispatch({ type: ADD_COURSE, payload: res.data });
    })
    .catch(err => {
      dispatch(returnErrors(err.response?.data || { msg: 'Network error' }, err.response?.status || 500));
    });
};

export const updateCourse = (id, course) => (dispatch, getState) => {
  // Get token but don't set Content-Type (browser will set it with boundary for FormData)
  const token = getState().auth.token;
  const config = {
    headers: {}
  };
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token;
  }

  return axios
    .put(`/api/courses/${id}`, course, config)
    .then(res => dispatch({ type: UPDATE_COURSE, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data || { msg: 'Network error' }, err.response?.status || 500)));
};

export const deleteCourse = id => (dispatch, getState) => {
  axios
    .delete(`/api/courses/${id}`, tokenConfig(getState))
    .then(res => dispatch({ type: DELETE_COURSE, payload: id }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

// Add submission form to course
export const addSubmissionFormToCourse = (courseId, submissionFormId) => (dispatch, getState) => {
  axios
    .post(`/api/courses/${courseId}/submissionForms`, { submissionFormId }, tokenConfig(getState))
    .then(res => dispatch({ type: UPDATE_COURSE, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

// Remove submission form from course
export const removeSubmissionFormFromCourse = (courseId, submissionFormId) => (dispatch, getState) => {
  axios
    .delete(`/api/courses/${courseId}/submissionForms/${submissionFormId}`, tokenConfig(getState))
    .then(res => dispatch({ type: UPDATE_COURSE, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

// Reorder course content
export const reorderCourseContent = (courseId, contentOrder) => (dispatch, getState) => {
  axios
    .put(`/api/courses/${courseId}/reorder`, { contentOrder }, tokenConfig(getState))
    .then(res => dispatch({ type: UPDATE_COURSE, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const setCoursesLoading = () => {
  return { type: COURSES_LOADING };
};

export const setCourseLoading = () => {
  return { type: COURSE_LOADING };
};

// Set current page number (without fetching data)
export const setCoursesPage = (page) => {
  return { type: SET_COURSES_PAGE, payload: page };
};
